<template>
    <Layout>
        <div class="container">
            <div class="source-wrap">
                <div class="left-content">
                    <div class="data-location">
                        <div class="title">
                            <div class="text">
                                导航
                            </div>
                            <div class="subText">
                                navigation
                            </div>
                        </div>
                        <div class="content">
                            <router-link :to="item.link"  v-for="(item,index) in navData" :key="index">
                                <div class="location-item" :class="{active:item.active}" v-if="!(item.name==='系统管理'&& student.type !== 1)">
                                    <div class="icon">
                                        <img :src=" require('./../../assets/image/manager/'+ item.icon +'') " alt="">
                                    </div>
                                    <div class="label">
                                        {{item.name}}
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="right-content">
                    <router-view></router-view>
                </div>
            </div>
        </div>

    </Layout>
</template>

<script>
  export default {
    data() {
      return {
        student:{},
        navData: [
          {
            name: '首页',
            icon: 'home.png',
            link:'/home',
            active:false
          },
          {
            name: '开始实验',
            icon: 'start.png',
            link:'/data/source',
            active:false
          },
          {
            name: '系统管理',
            icon: 'system.png',
            link: "/systemmanager/system",
            active:false
          },
          {
            name: '个人实验',
            icon: 'history.png',
            link: "/systemmanager/historical",
            active:false
          },
          {
            name: '学习室',
            icon: 'study.png',
            link: "/studyroom",
            active:false
          }
        ]
      }
    },
    created() {
      this.$axios.get('/login/current').then(res => {
        if (res.succeed) {
          this.student = res.student
        }
      })
    },
    methods: {
      getPageIndex(path) {
        this.navData.forEach((item) => {
          item.active = path.indexOf(item.link) > -1;
        })
      }
    },
    mounted() {
      this.getPageIndex(this.$route.fullPath)
    },
    beforeRouteUpdate(to, from, next) {
      this.getPageIndex(to.fullPath)
      next()
    }
  }
</script>

<style scoped lang="scss">
    @mixin title {
        padding: 30px 30px 0 30px;
        margin-bottom: 10px;
        .text {
            font-size: 26px;
            font-weight: bold;
            line-height: 33px;
        }
        .subText {
            font-size: 12px;
            font-weight: 400;
            line-height: 15px;
            color: #999999;
        }
    }

    .container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
    }

    .source-wrap {
        display: flex;
        width: 100%;
        max-width: 1600px;

        .left-content {
            width: 400px;
            min-width: 300px;
            height: 821px;
            margin-right: 40px;
            background: #FFFFFF;
            box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
            opacity: 1;
            border-radius: 12px;

            .data-location {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;

                .title {
                    @include title;
                    margin-bottom: 10px;
                }

                .content {
                    flex-grow: 1;

                    .location-item {
                        display: flex;
                        align-items: center;
                        height: 108px;
                        position: relative;
                        padding-left: 38px;

                        &.active {
                            background: #F1F1F1;

                            &:before {
                                content: '';
                                position: absolute;
                                left: 0;
                                height: 100%;
                                width: 6px;
                                background: #005BE7;
                            }
                        }

                        .icon {
                            width: 68px;
                            height: 68px;
                            margin-right: 24px;
                            background: linear-gradient(140deg, #70A0EB 0%, #005BE7 100%);
                            box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
                            border-radius: 50%;
                            text-align: center;
                            display: flex;
                            justify-content: center;
                            align-items: center;

                            img {
                                width: 40px;
                                height: 40px;
                                display: block;
                            }
                        }

                        .label {
                            font-size: 22px;
                            font-weight: 400;
                            line-height: 28px;
                            color: #999999;
                        }
                    }

                }

                .foot {
                    padding: 0 30px 30px 30px;

                    .submit-btn {
                        button {
                            width: 100%;
                            height: 64px;
                            background: linear-gradient(90deg, #70A0EB 0%, #005BE7 100%);
                            box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
                            opacity: 1;
                            border-radius: 60px;

                            .text {
                                font-size: 22px;
                                font-family: Microsoft YaHei UI, serif;
                                font-weight: 400;
                                line-height: 26px;
                                color: #FFFFFF;
                            }

                            .subText {
                                font-size: 10px;
                                font-weight: 400;
                                line-height: 14px;
                                color: #FFFFFF;
                            }
                        }
                    }
                }
            }
        }

        .right-content {
            position: relative;
            min-width: 500px;
            flex-grow: 1;
            flex-shrink: 1;
        }
    }


</style>
